export class RequestsReportModel {
    startDate: Date;
    endDate: Date;
    requestTypeIds: number[] = [];
    requestCategoryIds: number[] = [];
    authorUserIds: number[] = [];
    performerUserIds: number[] = [];
    withActivities: boolean;
    activityStatusKindId: number;
    isFinalActivities: boolean;
    searchMode: string = "requests";
    initTypeIds: number[] = [];
    contragentProjectIds: number[] = [];
}